import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _excluded = ["id", "description"];
import React from 'react';
import { css } from 'glamor';
import Toast from './toast';
var wrapperClass = css({
  maxWidth: 560,
  margin: '0 auto',
  top: 0,
  left: 0,
  right: 0,
  position: 'fixed',
  zIndex: 30
});
var hasCustomId = function hasCustomId(settings) {
  return Object.hasOwnProperty.call(settings, 'id');
};
var ToastManager = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ToastManager, _React$PureComponent);
  var _super = _createSuper(ToastManager);
  function ToastManager(props, context) {
    var _this;
    _classCallCheck(this, ToastManager);
    _this = _super.call(this, props, context);
    _this.getToasts = function () {
      return _this.state.toasts;
    };
    _this.closeAll = function () {
      _this.getToasts().forEach(function (toast) {
        return toast.close();
      });
    };
    _this.notify = function (title, settings) {
      // If there's a custom toast ID passed, close existing toasts with the same custom ID
      if (hasCustomId(settings)) {
        var _iterator = _createForOfIteratorHelper(_this.state.toasts),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var toast = _step.value;
            // Since unique ID is still appended to a custom ID, skip the unique ID and check only prefix
            if (String(toast.id).startsWith(settings.id)) {
              _this.closeToast(toast.id);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      var instance = _this.createToastInstance(title, settings);
      _this.setState(function (previousState) {
        return {
          toasts: [instance].concat(_toConsumableArray(previousState.toasts))
        };
      });
      return instance;
    };
    _this.createToastInstance = function (title, settings) {
      var uniqueId = ++ToastManager.idCounter;
      var id = hasCustomId(settings) ? "".concat(settings.id, "-").concat(uniqueId) : uniqueId;
      return {
        id: id,
        title: title,
        description: settings.description,
        hasCloseButton: settings.hasCloseButton || true,
        duration: settings.duration || 2,
        close: function close() {
          return _this.closeToast(id);
        },
        intent: settings.intent
      };
    };
    _this.closeToast = function (id) {
      _this.setState(function (previousState) {
        return {
          toasts: previousState.toasts.map(function (toast) {
            if (toast.id === id) {
              return _objectSpread(_objectSpread({}, toast), {}, {
                isShown: false
              });
            }
            return toast;
          })
        };
      });
    };
    _this.removeToast = function (id) {
      _this.setState(function (previousState) {
        return {
          toasts: previousState.toasts.filter(function (toast) {
            return toast.id !== id;
          })
        };
      });
    };
    props.bindNotify(_this.notify);
    props.bindGetToasts(_this.getToasts);
    props.bindCloseAll(_this.closeAll);
    _this.state = {
      toasts: []
    };
    return _this;
  }
  _createClass(ToastManager, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/React.createElement("span", {
        className: wrapperClass
      }, this.state.toasts.map(function (_ref) {
        var id = _ref.id,
          description = _ref.description,
          props = _objectWithoutProperties(_ref, _excluded);
        return /*#__PURE__*/React.createElement(Toast, Object.assign({
          key: id,
          onRemove: function onRemove() {
            return _this2.removeToast(id);
          }
        }, props), description);
      }));
    }
  }]);
  return ToastManager;
}(React.PureComponent);
ToastManager.idCounter = 0;
export { ToastManager as default };